import type { ColDef, ValueGetterParams } from 'ag-grid-enterprise'
import type { IInAppPrice } from '~/types/iap'

import CountryCellRenderer from '~/components/CellRenderers/CountryCellRenderer'
import TextCellRenderer from '~/components/CellRenderers/TextCellRenderer'
import countries from '~/const/countries.json'
import currencies from '~/const/currencies.json'

const pricesColumns: ColDef[] = [
  {
    cellRenderer: CountryCellRenderer,
    field: 'country',
    filter: true,
    headerName: 'Country',
    hide: false,
    sortable: true,
    valueGetter: ({ data }: ValueGetterParams<IInAppPrice, string>): string => {
      const isDataCountryAlpha3 = data && data.country.length > 2

      const alpha2CountryCode = isDataCountryAlpha3
        ? countries.find((country) => country['alpha-3'] === data?.country)?.['alpha-2'] || '--'
        : data?.country || '--'

      return data ? alpha2CountryCode : '--'
    },
  },
  {
    cellRenderer: TextCellRenderer,
    field: 'price',
    headerName: 'Price',
    minWidth: 100,
    suppressHeaderMenuButton: true,
  },
  {
    cellRenderer: TextCellRenderer,
    headerName: 'Currency',
    minWidth: 100,
    suppressHeaderMenuButton: true,
    valueGetter: ({ data }: ValueGetterParams<IInAppPrice, string>): string => {
      const currency = currencies.find((curr) => curr.alphabeticcode === data?.currency)?.currency || '--'

      return data ? currency : '--'
    },
  },
]

export default pricesColumns
